export interface CareerPositionCard {
  id: number;
  type: CareerPositionType,
  title: string;
  location: string;
  degreesDisplayText:string;
  industry:string;
  link:string;
  updateDateDisplayText:string;
}

export interface CareerPositionCardLayoutData {
  jobFieldTitle: string;
  locationTitle: string;
  externalPositionLabelText: string;
  externalPositionLabelType: CareerPositionLabelViewType;
  iternalPositionLabelText: string;
  iternalPositionLabelType: CareerPositionLabelViewType;
  researchAssistancePositionLabelText: string;
  researchAssistancePositionLabelType: CareerPositionLabelViewType;
  tellMeMoreAboutItLinkTitle: string;
  industryTitle:string;
  degreesTitle:string;
  updateDateTitle:string;
  internalLocationText:string;
}

export interface CareerPageData {
  nodeId: number;
  title: string;
  pageTitle: string;
  description: string;
  pageUrl: string;
  searchPlaceHolder: string;
  totalSearchResultCounterFormat: string;
  filtersSectionTitle: string;
  mobileFiltersShowBtnText: string;
  mobileFiltersClearBtnText: string;
  searchAutocompleteNoResultsText: string;
  noResultsTitle: string;
  noResultsText: string;
  noResultsImageUrl: string;
  noResultsClearAllBtnText: string;
  externalPositionLabelText: string;
  externalPositionLabelType: CareerPositionLabelViewType;
  iternalPositionLabelText: string;
  iternalPositionLabelType: CareerPositionLabelViewType;
  researchAssistancePositionLabelText: string;
  researchAssistancePositionLabelType: CareerPositionLabelViewType;
  locationTitle: string;
  jobFieldTitle: string;
  resetFiltersButtonText: string;
  tellMeMoreAboutItLinkTitle: string;
  pageSize: number;
  searchResults: CareerPageSearchResults;
  filters: CareerPageFiltersGroup[];
  sortingByDateOptionTitle: string;
  sortingByTitleOptionTitle: string;
  sortingByTypeOptionTitle: string;
  sortingDropdownPlaceholder: string;
  industryTitle:string;
  degreesTitle:string;
  updateDateTitle:string;
  internalLocationText:string
}

export interface CareerPageSearchResults
{
  currentPage: number;
  cards: CareerPositionCard[]
  totalSearchResultsCount: number;
}

export interface CareerPageFiltersGroup
{
  filterGroupTitle: string;
  filters: CareerPageFilter[];
}

export interface CareerPageFilter
{
  filterDisplayText: string;
  filterKey: number;
}

export enum CareerPositionsSorting {
  Type = 1,
  UpdateDate = 2,
  Title = 3
}

export enum CareerPositionLabelViewType
{
  DarkFill,
  LightFill,
  LightBorder,
}

export enum CareerPositionType
{
  Internal=1,
  External=2,
  AssistantsResearch=3
}